const zhCN = {
  noClose: '这是最后一个标签了, 无法被关闭！',
  leftNoLabel: '左侧没有标签！',
  rightNoLabel: '右侧没有标签！',

  closeCurrentBtn: '关闭当前标签',
  closeRightBtn: '关闭右侧',
  closeLeftBtn: '关闭左侧',
  closeAllBtn: '关闭全部'
}
const enUS = {
  noClose: 'This is the last TAB and cannot be closed!',
  leftNoLabel: 'No TAB on the left!',
  rightNoLabel: 'No TAB on the right!',

  closeCurrentBtn: 'Close',
  closeRightBtn: 'Close Right',
  closeLeftBtn: 'Close Left',
  closeAllBtn: 'Close All'
}

export default { zhCN, enUS }